import { render, staticRenderFns } from "./AddClientFormFormal.vue?vue&type=template&id=2c902b82&"
import script from "./AddClientFormFormal.vue?vue&type=script&lang=js&"
export * from "./AddClientFormFormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports